export const regularizationActionTypes = {
  SET_STATE: 'regularization/SET_STATE',
  GET_REQUESTS: 'regularization/GET_REQUESTS',
  CREATE_REQUEST: 'regularization/CREATE_REQUEST',
  UPDATE_REQUEST: 'regularization/UPDATE_REQUEST',
  DELETE_REQUEST: 'regularization/DELETE_REQUEST',
  APPROVE_REQUEST: 'regularization/APPROVE_REQUEST',
  DECLINE_REQUEST: 'regularization/DECLINE_REQUEST',
  GET_MANAGER_REQUESTS: 'regularization/GET_MANAGER_REQUESTS',
};
